export const PERMISSIONS = {
  activities: {
    add: {
      driveractivity: 'activities.add_driveractivity',
      driverlocation: 'activities.add_driverlocation',
      userdatestartendlocation: 'activities.add_userdatestartendlocation',
    },
    change: {
      driveractivity: 'activities.change_driveractivity',
      driveractivitypaidstatus: 'activities.change_driveractivitypaidstatus',
      driverlocation: 'activities.change_driverlocation',
      userdatestartendlocation: 'activities.change_userdatestartendlocation',
      driverdiet: 'activities.change_driverdiet',
    },
    delete: {
      driveractivity: 'activities.delete_driveractivity',
      driverlocation: 'activities.delete_driverlocation',
      userdatestartendlocation: 'activities.delete_userdatestartendlocation',
    },
    view: {
      driveractivity: 'activities.view_driveractivity',
      driverlocation: 'activities.view_driverlocation',
      userdatestartendlocation: 'activities.view_userdatestartendlocation',
    },
    approve: {
      driveractivity: 'activities.approve_driveractivity',
      othersdriveractivity: 'activities.approve_othersdriveractivity',
    },
  },
  admin: {
    add: {
      logentry: 'admin.add_logentry',
    },
    change: {
      logentry: 'admin.change_logentry',
    },
    delete: {
      logentry: 'admin.delete_logentry',
    },
    view: {
      logentry: 'admin.view_logentry',
    },
  },
  auth: {
    add: {
      group: 'auth.add_group',
      permission: 'auth.add_permission',
    },
    change: {
      group: 'auth.change_group',
      permission: 'auth.change_permission',
    },
    delete: {
      group: 'auth.delete_group',
      permission: 'auth.delete_permission',
    },
    view: {
      group: 'auth.view_group',
      permission: 'auth.view_permission',
    },
  },
  checklists: {
    change: {
      checklisttemplate: 'checklists.change_checklisttemplate',
    },
    add: {
      checklisttemplate: 'checklists.add_checklisttemplate',
    },
  },
  companies: {
    add: {
      company: 'companies.add_company',
      companyapikey: 'companies.add_companyapikey',
      companysetting: 'companies.add_companysetting',
      vehicleGroup: 'companies.add_companyvehiclegroup',
    },
    change: {
      company: 'companies.change_company',
      company_general_settings: 'companies.change_company_general_settings',
      company_sms_settings: 'companies.change_company_sms_settings',
      companyapikey: 'companies.change_companyapikey',
      companysetting: 'companies.change_companysetting',
      vehicleGroup: 'companies.change_companyvehiclegroup',
    },
    delete: {
      company: 'companies.delete_company',
      companyapikey: 'companies.delete_companyapikey',
      companysetting: 'companies.delete_companysetting',
      vehicleGroup: 'companies.delete_companyvehiclegroup',
    },
    view: {
      company: 'companies.view_company',
      companyapikey: 'companies.view_companyapikey',
      companysetting: 'companies.view_companysetting',
      vehicleGroup: 'companies.view_companyvehiclegroup',
    },
    export: {
      exportReports: 'companies.export_reports',
    },
  },
  contenttypes: {
    add: {
      contenttype: 'contenttypes.add_contenttype',
    },
    change: {
      contenttype: 'contenttypes.change_contenttype',
    },
    delete: {
      contenttype: 'contenttypes.delete_contenttype',
    },
    view: {
      contenttype: 'contenttypes.view_contenttype',
    },
  },
  django_celery_beat: {
    add: {
      clockedschedule: 'django_celery_beat.add_clockedschedule',
      crontabschedule: 'django_celery_beat.add_crontabschedule',
      intervalschedule: 'django_celery_beat.add_intervalschedule',
      periodictask: 'django_celery_beat.add_periodictask',
      periodictasks: 'django_celery_beat.add_periodictasks',
      solarschedule: 'django_celery_beat.add_solarschedule',
    },
    change: {
      clockedschedule: 'django_celery_beat.change_clockedschedule',
      crontabschedule: 'django_celery_beat.change_crontabschedule',
      intervalschedule: 'django_celery_beat.change_intervalschedule',
      periodictask: 'django_celery_beat.change_periodictask',
      periodictasks: 'django_celery_beat.change_periodictasks',
      solarschedule: 'django_celery_beat.change_solarschedule',
    },
    delete: {
      clockedschedule: 'django_celery_beat.delete_clockedschedule',
      crontabschedule: 'django_celery_beat.delete_crontabschedule',
      intervalschedule: 'django_celery_beat.delete_intervalschedule',
      periodictask: 'django_celery_beat.delete_periodictask',
      periodictasks: 'django_celery_beat.delete_periodictasks',
      solarschedule: 'django_celery_beat.delete_solarschedule',
    },
    view: {
      clockedschedule: 'django_celery_beat.view_clockedschedule',
      crontabschedule: 'django_celery_beat.view_crontabschedule',
      intervalschedule: 'django_celery_beat.view_intervalschedule',
      periodictask: 'django_celery_beat.view_periodictask',
      periodictasks: 'django_celery_beat.view_periodictasks',
      solarschedule: 'django_celery_beat.view_solarschedule',
    },
  },
  django_celery_results: {
    add: {
      taskresult: 'django_celery_results.add_taskresult',
    },
    change: {
      taskresult: 'django_celery_results.change_taskresult',
    },
    delete: {
      taskresult: 'django_celery_results.delete_taskresult',
    },
    view: {
      taskresult: 'django_celery_results.view_taskresult',
    },
  },
  handbook: {
    add: {
      manualentry: 'handbook.add_manualentry',
      manualentryattachment: 'handbook.add_manualentryattachment',
      manualfolder: 'handbook.add_manualfolder',
      form: 'handbook.add_form',
    },
    change: {
      manualentry: 'handbook.change_manualentry',
      manualentryattachment: 'handbook.change_manualentryattachment',
      manualfolder: 'handbook.change_manualfolder',
      form: 'handbook.change_form',
    },
    delete: {
      manualentry: 'handbook.delete_manualentry',
      manualentryattachment: 'handbook.delete_manualentryattachment',
      manualfolder: 'handbook.delete_manualfolder',
      form: 'handbook.delete_form',
    },
    view: {
      manualentry: 'handbook.view_manualentry',
      manualentryattachment: 'handbook.view_manualentryattachment',
      manualfolder: 'handbook.view_manualfolder',
      form: 'handbook.view_form',
    },
  },
  dynamic_tables: {
    add: {
      dynamiccolumn: 'dynamic_tables.add_dynamiccolumn',
    },
    change: {
      dynamiccolumn: 'dynamic_tables.change_dynamiccolumn',
    },
    delete: {
      dynamiccolumn: 'dynamic_tables.delete_dynamiccolumn',
    },
    view: {
      dynamiccolumn: 'dynamic_tables.view_dynamiccolumn',
    },
  },
  formcreator: {
    add: {
      formtemplate: 'formcreator.add_formtemplate',
      formtemplatevalue: 'formcreator.add_formtemplatefield',
      filledoutform: 'formcreator.add_filledoutform',
      filledoutformvalue: 'formcreator.add_filledoutformvalue',
    },
    change: {
      formtemplate: 'formcreator.change_formtemplate',
      formtemplatevalue: 'formcreator.change_formtemplatefield',
      filledoutform: 'formcreator.change_filledoutform',
      filledoutformvalue: 'formcreator.change_filledoutformvalue',
    },
    delete: {
      formtemplate: 'formcreator.delete_formtemplate',
      formtemplatevalue: 'formcreator.delete_formtemplatefield',
      filledoutform: 'formcreator.delete_filledoutform',
      filledoutformvalue: 'formcreator.delete_filledoutformvalue',
    },
    view: {
      formtemplate: 'formcreator.view_formtemplate',
      formtemplatevalue: 'formcreator.view_formtemplatefield',
      filledoutform: 'formcreator.view_filledoutform',
      filledoutformvalue: 'formcreator.view_filledoutformvalue',
    },
  },
  fleet: {
    add: {
      vehiclegroup: 'fleet.add_vehiclegroup',
      fleetbooleanfilter: 'fleet.add_fleetbooleanfilter',
    },
    change: {
      vehiclegroup: 'fleet.change_vehiclegroup',
      fleetbooleanfilter: 'fleet.change_fleetbooleanfilter',
    },
    delete: {
      vehiclegroup: 'fleet.delete_vehiclegroup',
      fleetbooleanfilter: 'fleet.delete_fleetbooleanfilter',
    },
    view: {
      vehiclegroup: 'fleet.view_vehiclegroup',
      fleetbooleanfilter: 'fleet.view_fleetbooleanfilter',
    },
  },
  forum: {
    add: {
      post: 'forum.add_post',
      postattachment: 'forum.add_postattachment',
      thread: 'forum.add_thread',
      threadattachment: 'forum.add_threadattachment',
      threaduserinteraction: 'forum.add_threaduserinteraction',
    },
    change: {
      post: 'forum.change_post',
      postattachment: 'forum.change_postattachment',
      sticky: 'forum.change_sticky',
      thread: 'forum.change_thread',
      threadattachment: 'forum.change_threadattachment',
      threaduserinteraction: 'forum.change_threaduserinteraction',
    },
    delete: {
      post: 'forum.delete_post',
      postattachment: 'forum.delete_postattachment',
      thread: 'forum.delete_thread',
      threaduserinteraction: 'forum.delete_threaduserinteraction',
    },
    view: {
      post: 'forum.view_post',
      postattachment: 'forum.view_postattachment',
      thread: 'forum.view_thread',
      threadattachment: 'forum.view_threadattachment',
      threaduserinteraction: 'forum.view_threaduserinteraction',
    },
    send: {
      thread_email: 'forum.send_thread_email',
      thread_sms: 'forum.send_thread_sms',
    },
  },
  infringements: {
    add: {
      infringement: 'infringements.add_infringement',
    },
    change: {
      infringement: 'infringements.change_infringement',
    },
    delete: {
      infringement: 'infringements.delete_infringement',
    },
    view: {
      infringement: 'infringements.view_infringement',
      othersinfringement: 'infringements.view_othersinfringement',
    },
  },
  issues: {
    add: {
      issue: 'issues.add_issue',
      issueattachment: 'issues.add_issueattachment',
      issuecategory: 'issues.add_issuecategory',
    },
    change: {
      issue: 'issues.change_issue',
      issueattachment: 'issues.change_issueattachment',
      issuecategory: 'issues.change_issuecategory',
    },
    delete: {
      issue: 'issues.delete_issue',
      issueattachment: 'issues.delete_issueattachment',
      issuecategory: 'issues.delete_issuecategory',
    },
    view: {
      issue: 'issues.view_issue',
      issueattachment: 'issues.view_issueattachment',
      issuecategory: 'issues.view_issuecategory',
      othersissue: 'issues.view_othersissue',
    },
  },
  planner: {
    view: {
      calendaritem: 'planner.view_calendaritem',
      unownedcalendaritem: 'planner.view_unownedcalendaritem',
      calendarscheduledynamic: 'planner.view_calendarscheduledynamic',
      calendarscheduledynamictemplate:
        'planner.view_calendarscheduledynamictemplate',
      calendarschedulestatic: 'planner.view_calendarschedulestatic',
      calendarschedulestatictemplate:
        'planner.view_calendarschedulestatictemplate',
      calendaritemcomment: 'planner.view_calendaritemcomment',
    },
    add: {
      calendaritem: 'planner.add_calendaritem',
      unownedcalendaritem: 'planner.add_unownedcalendaritem',
      calendarscheduledynamic: 'planner.add_calendarscheduledynamic',
      calendarscheduledynamictemplate:
        'planner.add_calendarscheduledynamictemplate',
      calendarschedulestatic: 'planner.add_calendarschedulestatic',
      calendarschedulestatictemplate:
        'planner.add_calendarschedulestatictemplate',
      calendaritemcomment: 'planner.add_calendaritemcomment',
    },
    change: {
      calendaritem: 'planner.change_calendaritem',
      unownedcalendaritem: 'planner.change_unownedcalendaritem',
      calendarscheduledynamic: 'planner.change_calendarscheduledynamic',
      calendarscheduledynamictemplate:
        'planner.change_calendarscheduledynamictemplate',
      calendarschedulestatic: 'planner.change_calendarschedulestatic',
      calendarschedulestatictemplate:
        'planner.change_calendarschedulestatictemplate',
      calendaritemcomment: 'planner.change_calendaritemcomment',
    },
    delete: {
      calendaritem: 'planner.delete_calendaritem',
      unownedcalendaritem: 'planner.delete_unownedcalendaritem',
      calendarscheduledynamic: 'planner.delete_calendarscheduledynamic',
      calendarscheduledynamictemplate:
        'planner.delete_calendarscheduledynamictemplate',
      calendarschedulestatic: 'planner.delete_calendarschedulestatic',
      calendarschedulestatictemplate:
        'planner.delete_calendarschedulestatictemplate',
      calendaritemcomment: 'planner.delete_calendaritemcomment',
    },
  },
  routePlanner: {
    add: {
      routePlan: 'route_planner.add_routeplan',
      routeRestriction: 'route_planner.add_routerestriction',
      routeWeightRestriction: 'route_planner.add_routeweightrestriction',
    },
    change: {
      routePlan: 'route_planner.change_routeplan',
    },
    delete: {
      routePlan: 'route_planner.delete_routeplan',
    },
    view: {
      route: 'route_planner.view_route',
      routePlan: 'route_planner.view_routeplan',
      routePlanInstruction: 'route_planner.view_routeplaninstruction',
      routePlanNotice: 'route_planner.view_routeplannotice',
      routePlanNoticeDetail: 'route_planner.view_routeplannoticedetail',
      routePlanPoint: 'route_planner.view_routeplanpoint',
      routeRestriction: 'route_planner.view_routerestriction',
      routeWeightRestriction: 'route_planner.view_routeweightrestriction',
    },
  },
  salary: {
    view: {
      timeaddon: 'salary.view_timeaddon',
      timeoverride: 'salary.view_timeoverride',
      fixedaddon: 'salary.view_fixedaddon',
      salarybase: 'salary.view_salarybase',
      salarybaseentry: 'salary.view_salarybaseentry',
      salaryMode: 'salary.view_salarymode',
    },
    add: {
      timeaddon: 'salary.add_timeaddon',
      timeoverride: 'salary.add_timeoverride',
      fixedaddon: 'salary.add_fixedaddon',
      salarybase: 'salary.add_salarybase',
      salarybaseentry: 'salary.add_salarybaseentry',
      salaryMode: 'salary.add_salarymode',
    },
    change: {
      timeaddon: 'salary.change_timeaddon',
      timeoverride: 'salary.change_timeoverride',
      fixedaddon: 'salary.change_fixedaddon',
      salarybase: 'salary.change_salarybase',
      salarybaseentry: 'salary.change_salarybaseentry',
      salaryMode: 'salary.change_salarymode',
      salarySetting: 'salary.change_salarysetting',
    },
    delete: {
      timeaddon: 'salary.delete_timeaddon',
      timeoverride: 'salary.delete_timeoverride',
      fixedaddon: 'salary.delete_fixedaddon',
      salarybase: 'salary.delete_salarybase',
      salarybaseentry: 'salary.delete_salarybaseentry',
      salaryMode: 'salary.delete_salarymode',
    },
    approve: {
      workperiod: 'salary.approve_workperiod',
    },
  },
  workPeriod: {
    view: {
      workperiod: 'salary.view_workperiod',
      othersworkperiod: 'salary.view_othersworkperiod',
    },
    change: {
      workperiod: 'salary.change_workperiod',
      salarysetting: 'salary.change_salarysetting',
    },
    approve: {
      workperiod: 'salary.approve_workperiod',
    },
  },
  sessions: {
    add: {
      session: 'sessions.add_session',
    },
    change: {
      session: 'sessions.change_session',
    },
    delete: {
      session: 'sessions.delete_session',
    },
    view: {
      session: 'sessions.view_session',
    },
  },
  sms: {
    add: {
      smsrecord: 'sms.add_smsrecord',
    },
    change: {
      smsrecord: 'sms.change_smsrecord',
    },
    delete: {
      smsrecord: 'sms.delete_smsrecord',
    },
    view: {
      smsrecord: 'sms.view_smsrecord',
    },
  },
  terminal: {
    add: {
      terminal: 'terminal.add_terminal',
      terminalentry: 'terminal.add_terminalentry',
    },
    change: {
      terminal: 'terminal.change_terminal',
      terminalentry: 'terminal.change_terminalentry',
    },
    delete: {
      terminal: 'terminal.delete_terminal',
      terminalentry: 'terminal.delete_terminalentry',
    },
    view: {
      terminal: 'terminal.view_terminal',
      terminalentry: 'terminal.view_terminalentry',
    },
  },
  timesheets: {
    add: {
      absence: 'timesheets.add_absence',
      absencetype: 'timesheets.add_absencetype',
      absencelockconfig: 'timesheets.add_absencelockconfig',
      absencelockrule: 'timesheets.add_absencelockrule',
      absencelockoverride: 'timesheets.add_absencelockoverride',
      absencecomment: 'timesheets.add_absencecomment',
      checkinout: 'timesheets.add_timeentry_checkinout',
      timeentry: 'timesheets.add_timeentry',
      othersabsence: 'timesheets.add_othersabsence',
      absencehourtransaction: 'timesheets.add_absencehourtransaction',
      absencehourtransactionother: 'timesheets.add_absencehourtransactionother',
    },
    change: {
      absence: 'timesheets.change_absence',
      absencetype: 'timesheets.change_absencetype',
      absencelockconfig: 'timesheets.change_absencelockconfig',
      absencelockrule: 'timesheets.change_absencelockrule',
      absencelockoverride: 'timesheets.change_absencelockoverride',
      absencecomment: 'timesheets.change_absencecomment',
      checkinout: 'timesheets.change_timeentry_checkinout',
      timeentry: 'timesheets.change_timeentry',
      othersabsence: 'timesheets.change_othersabsence',
      absencehourtransaction: 'timesheets.change_absencehourtransaction',
    },
    delete: {
      absence: 'timesheets.delete_absence',
      absencetype: 'timesheets.delete_absencetype',
      absencelockconfig: 'timesheets.delete_absencelockconfig',
      absencelockrule: 'timesheets.delete_absencelockrule',
      absencelockoverride: 'timesheets.delete_absencelockoverride',
      absencecomment: 'timesheets.delete_absencecomment',
      timeentry: 'timesheets.delete_timeentry',
      othersabsence: 'timesheets.delete_othersabsence',
      absencehourtransaction: 'timesheets.delete_absencehourtransaction',
    },
    view: {
      absence: 'timesheets.view_absence',
      absencetype: 'timesheets.view_absencetype',
      absencelockconfig: 'timesheets.view_absencelockconfig',
      absencelockrule: 'timesheets.view_absencelockrule',
      absencelockoverride: 'timesheets.view_absencelockoverride',
      absenceperiodreport: 'timesheets.view_absenceperiodreport',
      absenceperiodreportother: 'timesheets.view_absenceperiodreportother',
      absencecomment: 'timesheets.view_absencecomment',
      othersabsence: 'timesheets.view_othersabsence',
      otherstimeentry: 'timesheets.view_otherstimeentry',
      timeentry: 'timesheets.view_timeentry',
      absencehourtransaction: 'timesheets.view_absencehourtransaction',
    },
    overrideTimeEntrySalaryCode: 'timesheets.override_timeentrysalarycode',
  },
  users: {
    add: {
      driver_card: 'users.add_drivercard',
      dropdown: 'users.add_dropdown',
      user: 'users.add_user',
      userchild: 'users.add_userchild',
      userchildother: 'users.add_userchildother',
      userdocument: 'users.add_userdocument',
      userequipment: 'users.add_userequipment',
      userequipmenttype: 'users.add_userequipmenttype',
      userfetchinfo: 'integrations.add_userfetchinfo',
      usersetting: 'users.add_usersetting',
      usertype: 'users.add_usertype',
    },
    change: {
      driver_card_number: 'users.change_driver_card_number',
      driver_card: 'users.change_drivercard',
      dropdown: 'users.change_dropdown',
      user: 'users.change_user',
      userchild: 'users.change_userchild',
      userchildother: 'users.change_userchildother',
      userdocument: 'users.change_userdocument',
      userequipment: 'users.change_userequipment',
      userequipmenttype: 'users.change_userequipmenttype',
      userfetchinfo: 'integrations.change_userfetchinfo',
      usersetting: 'users.change_usersetting',
      usertype_is_administrator: 'users.change_usertype_is_administrator',
      usertype: 'users.change_usertype',
    },
    delete: {
      driver_card: 'users.delete_drivercard',
      user: 'users.delete_user',
      userchild: 'users.delete_userchild',
      userchildother: 'users.delete_userchildother',
      userdocument: 'users.delete_userdocument',
      userequipment: 'users.delete_userequipment',
      userequipmenttype: 'users.delete_userequipmenttype',
      userfetchinfo: 'integrations.delete_userfetchinfo',
      usersetting: 'users.delete_usersetting',
      usertype: 'users.delete_usertype',
    },
    view: {
      driver_card: 'users.view_drivercard',
      user: 'users.view_user',
      userchild: 'users.view_userchild',
      userchildother: 'users.view_userchildother',
      userdocument: 'users.view_userdocument',
      userequipment: 'users.view_userequipment',
      userequipmenttype: 'users.view_userequipmenttype',
      userfetchinfo: 'integrations.view_userfetchinfo',
      usersetting: 'users.view_usersetting',
      usertype: 'users.view_usertype',
    },
  },
  vehicles: {
    add: {
      vehicle: 'vehicles.add_vehicle',
      vehiclefetchinfo: 'integrations.add_vehiclefetchinfo',
      vehicledocument: 'vehicles.add_vehicledocument',
      vehicleexpiration: 'vehicles.add_vehicleexpiration',
      vehiclenote: 'vehicles.add_vehiclenote',
    },
    change: {
      vehicle: 'vehicles.change_vehicle',
      vehiclefetchinfo: 'integrations.change_vehiclefetchinfo',
      vehicledocument: 'vehicles.change_vehicledocument',
      vehicleexpiration: 'vehicles.change_vehicleexpiration',
      vehiclenote: 'vehicles.change_vehiclenote',
    },
    delete: {
      vehicle: 'vehicles.delete_vehicle',
      vehiclefetchinfo: 'integrations.delete_vehiclefetchinfo',
      vehicledocument: 'vehicles.delete_vehicledocument',
      vehicleexpiration: 'vehicles.delete_vehicleexpiration',
      vehiclenote: 'vehicles.delete_vehiclenote',
    },
    view: {
      vehicle: 'vehicles.view_vehicle',
      vehiclefetchinfo: 'integrations.view_vehiclefetchinfo',
      vehicledocument: 'vehicles.view_vehicledocument',
      vehicleexpiration: 'vehicles.view_vehicleexpiration',
      vehiclenote: 'vehicles.view_vehiclenote',
    },
  },
}
